"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.keys");

require("core-js/modules/web.dom-collections.for-each");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = _interopRequireDefault(require("./utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = [{
  label: 'Validations',
  key: 'validations',
  input: true,
  type: 'editgrid',
  inlineEdit: true,
  templates: {
    header: "<div class=\"row\">\n          <div class=\"col-sm-6\">Description</div>\n          <div class=\"col-sm-2\">Group</div>\n          <div class=\"col-sm-2\">Severity</div>\n          <div class=\"col-sm-2\">Actions</div>\n        </div>",
    row: "<div class=\"row\">\n          <div class=\"col-sm-6\">{{ row.description ? row.description : flattenedComponents.condition.getView(row.condition) }}</div>\n          <div class=\"col-sm-2\">{{ row.group }}</div>\n          <div class=\"col-sm-2\">{{ flattenedComponents.severity.getView(row.severity) }}</div>\n          <div class=\"col-sm-2\">\n            <button class=\"btn btn-default btn-light btn-sm editRow\">Edit</button>\n            <button class=\"btn btn-danger btn-sm removeRow\">Delete</button>\n          </div>\n        </div>"
  },
  addAnother: 'Add Validation',
  saveRow: 'Save Validation',
  components: [{
    type: 'checkbox',
    label: 'Active',
    key: 'active',
    input: true,
    defaultValue: true
  }, _objectSpread(_objectSpread({}, _utils.default.conditionSelector()), {}, {
    validate: {
      required: true
    }
  }), {
    type: 'textfield',
    label: 'Group',
    key: 'group',
    input: true
  }, {
    type: 'textfield',
    label: 'Description',
    key: 'description',
    input: true
  }, {
    type: 'radio',
    label: 'Severity',
    key: 'severity',
    inline: true,
    input: true,
    values: [{
      label: 'Error',
      value: 'error'
    }, {
      label: 'Warning',
      value: 'warning'
    }, {
      label: 'Info',
      value: 'info'
    }],
    validate: {
      required: true
    }
  }, {
    type: 'textfield',
    label: 'Message',
    key: 'message',
    input: true
  }]
}];
exports.default = _default;